import React, { useEffect, useState } from 'react';

import { orderBy } from 'lodash';

import styled from 'styled-components';

import { useStateValue } from '@contexts/StateProvider';

import { useProject, onGetOrderedEventList } from '@hooks/API/Project/UseProject';
import { useTransaction } from '@hooks/API/UseTransaction';

import { Loading } from '@components/Gui/Loading';
import NwDivider from '@components/Gui/NwDivider';
import NwIcon from '@components/Gui/NwIcon';
import ServerError from '@components/Gui/ServerError';
import ProjectSelector from '@components/ProjectSelector/ProjectSelector';
import TransactionAddMotAgCommission from '@components/Transactions/TransactionsDrawer/TransactionAddMotAgCommission';
import TransactionAmount from '@components/Transactions/TransactionsDrawer/TransactionAmount';
import TransactionItemDetailForm from '@components/Transactions/TransactionsDrawer/TransactionDetailForms/TransactionItemDetailForm';
import TransactionStatementDetails from '@components/Transactions/TransactionsDrawer/TransactionStatementDetails';

import TransactionLockStatus from './TransactionLockStatus';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const BackContainer = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-bottom: 16px;
`;

const BackIconStyle = {
    marginRight: 8,
};

const TransactionDetails = ({
    transaction,
    projectId,
    onUpdateTransaction,
    onBack,
    onTouchForm,
    onTransactionRemoved,
    hideProject,
}) => {
    const [{ areaContext }] = useStateValue();
    const {
        data: transactionData,
        isFetching: loadingTransaction,
        isError,
        error,
    } = useTransaction(transaction.ID, transaction.Family);

    // const { data: currentProject, isFetching: loadingProject } = useProject(projectId);
    const [accountingUnlock, setAccountingUnlock] = useState(false);

    // useEffect(() => {
    //     if (currentProject) {
    //         onGetOrderedEventList(currentProject, areaContext);
    //     }
    // }, [currentProject]);

    const onUnlockingTransaction = () => {
        setAccountingUnlock(true);
    };

    const onLockingTransaction = () => {
        setAccountingUnlock(false);
    };

    return loadingTransaction ? ( //loadingProject ||
        <Loading textBlack />
    ) : isError ? (
        <ServerError error={error} />
    ) : (
        <>
            {onBack && (
                <BackContainer onClick={onBack}>
                    <NwIcon icon={byPrefixAndName.fasl['arrow-left']} style={BackIconStyle} />
                    Back
                </BackContainer>
            )}
            {!hideProject && <ProjectSelector readOnly value={projectId} onChange />}
            <TransactionLockStatus
                transaction={transactionData}
                accountingUnlock={accountingUnlock}
                onUnlockingTransaction={onUnlockingTransaction}
                onLockingTransaction={onLockingTransaction}
            />
            <TransactionItemDetailForm
                transaction={transactionData}
                onUpdateTransaction={onUpdateTransaction}
                onTouchForm={onTouchForm}
                onTransactionRemoved={onTransactionRemoved}
                accountingUnlock={accountingUnlock}
            />
            <TransactionAmount
                transaction={transactionData}
                onUpdateTransaction={onUpdateTransaction}
                onTouchForm={onTouchForm}
                accountingUnlock={accountingUnlock}
            />
            {transactionData.ClientStatements.length > 0 && (
                <div className="transaction-statement-container">
                    <NwDivider textSize="medium" icon={byPrefixAndName.fasl['address-card']} dark>
                        client
                    </NwDivider>
                    <TransactionStatementDetails
                        accountingUnlock={accountingUnlock}
                        transaction={transactionData}
                        transactionId={transactionData.ID}
                        type="client"
                        statements={transactionData.ClientStatements}
                        onUpdateTransaction={onUpdateTransaction}
                        onTouchForm={onTouchForm}
                    />
                </div>
            )}
            {transactionData.ModelStatements.length > 0 && (
                <div className="transaction-statement-container">
                    <NwDivider textSize="medium" icon={byPrefixAndName.fasl['address-card']} dark>
                        model
                    </NwDivider>
                    <TransactionStatementDetails
                        accountingUnlock={accountingUnlock}
                        transaction={transactionData}
                        transactionId={transactionData.ID}
                        type="model"
                        statements={transactionData.ModelStatements}
                        onUpdateTransaction={onUpdateTransaction}
                        onTouchForm={onTouchForm}
                    />
                </div>
            )}
            {transactionData.AgencyStatements.length > 0 && (
                <div className="transaction-statement-container">
                    <NwDivider textSize="medium" icon={byPrefixAndName.fasl['globe']} dark>
                        agency
                    </NwDivider>
                    {orderBy(transactionData.AgencyStatements, 'amount')
                        .reverse()
                        .map((statement, index) => (
                            <TransactionStatementDetails
                                accountingUnlock={accountingUnlock}
                                transaction={transactionData}
                                transactionId={transactionData.ID}
                                type="agency"
                                statements={[statement]}
                                onUpdateTransaction={onUpdateTransaction}
                                onTouchForm={onTouchForm}
                            />
                        ))}
                </div>
            )}
            {transaction.Family.toLowerCase() === 'jobfee' && (
                <div style={{ marginTop: '2rem' }}>
                    <TransactionAddMotAgCommission transaction={transactionData} accountingUnlock={accountingUnlock} />
                </div>
            )}
        </>
    );
};

export default TransactionDetails;
